import { render, staticRenderFns } from "./BookingAlertTermsAndConditions.vue?vue&type=template&id=28130a46"
import script from "./BookingAlertTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./BookingAlertTermsAndConditions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports